import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SolicitudesOrdenesFisicasService } from 'src/app/services/empresa/solicitudes-ordenes-fisicas.service';

@Component({
    selector: 'app-ordenes-fisicas-solicitudes',
    templateUrl: './ordenes-fisicas-solicitudes.component.html',
    styleUrls: ['./ordenes-fisicas-solicitudes.component.scss'],
    standalone: false
})
export class OrdenesFisicasSolicitudesComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public solicitudes: any[] = [];
  public detalle2D: any[] = [];
  public solicitudSeleccionada: any = null;
  public cargando = false;
  public buscando = false;
  public txtSecuencia = '';

  constructor(
    private solicitudesOrdenesFisicasService: SolicitudesOrdenesFisicasService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: LanguageApp.spanish_datatables
    };

    this.obtenerSolicitudes();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  obtenerSolicitudes() {
    this.cargando = true;

    this.solicitudesOrdenesFisicasService.listarSolicitudes(localStorage.getItem('token') || '').subscribe({
      next: (resp: any) => {
        const data = Array.isArray(resp) ? resp : resp?.rows ?? resp?.data ?? [];
        this.solicitudes = data;
        this.cargando = false;

        if (!this.isDtInitialized) {
          this.dtTrigger.next(null);
          this.isDtInitialized = true;
          return;
        }

        this.rerender();
      },
      error: () => {
        this.solicitudes = [];
        this.cargando = false;
      }
    });
  }

  buscarSecuencia() {
    const secuencia = this.txtSecuencia.trim();

    if (!secuencia) {
      this.obtenerSolicitudes();
      return;
    }

    this.router.navigate(['/sistema/ordenes-fisicas-seguimiento-blocks'], {
      queryParams: { busquedaGlobal: secuencia }
    });
  }

  nuevaSolicitud() {
    this.router.navigate(['/sistema/ordenes-fisicas-nueva-solicitud']);
  }

  verDuplicados() {
    this.toastr.info('Pendiente migrar la pantalla de blocks duplicados.', 'Atención', {
      timeOut: 3000,
      closeButton: true,
      progressBar: true
    });
  }

  get totalSolicitudes(): number {
    return this.solicitudes.length;
  }

  get totalOrdenes(): number {
    return this.solicitudes.reduce((acc, item) => acc + Number(item?.TOT_SOLORD || 0), 0);
  }

  get totalBlocks(): number {
    return this.totalOrdenes / 25;
  }

  async verAsignaciones2D(modal: any, solicitud: any) {
    this.detalle2D = [];
    this.solicitudSeleccionada = solicitud;

    let detalle: any[] = [];
    try {
      detalle = JSON.parse(solicitud.DETBLOCK_SOLORD || '[]');
    } catch {
      detalle = [];
    }

    const detalleConDisponibles = await Promise.all(
      detalle.map(async (item: any) => {
        const secuencia = String(item.secuencia || '');
        const rangos = secuencia.split(' - ').map((valor: string) => valor.trim());
        const desde = rangos[0] || '';
        const hasta = rangos[1] || '';

        let disponibles = 0;
        try {
          const resp: any = await firstValueFrom(
            this.solicitudesOrdenesFisicasService.totalBlocksDisponibles(
              localStorage.getItem('token') || '',
              String(solicitud.COD_SOLORD),
              desde,
              hasta
            )
          );

          const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
          disponibles = rows[0]?.TOTAL ?? 0;
        } catch {
          disponibles = 0;
        }

        return {
          ...item,
          disponibles
        };
      })
    );

    this.detalle2D = detalleConDisponibles;
    this.modalService.open(modal, { centered: true, size: 'xl' });
  }

  visualizarAsignacion(item: any) {
    if (!this.solicitudSeleccionada?.COD_SOLORD) {
      this.toastr.error('No se pudo identificar la solicitud.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    this.modalService.dismissAll();
    this.router.navigate(['/sistema/ordenes-fisicas-seguimiento-blocks'], {
      queryParams: {
        solicitud: this.solicitudSeleccionada.COD_SOLORD,
        secuencia: item.secuencia,
        precio2D: item.precios2D,
        numeroBlocks: item.numeroBlocks
      }
    });
  }

  private rerender(): void {
    if (!this.dtElement) {
      return;
    }

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: {
      first: 'Primero',
      previous: 'Ant',
      next: 'Sig',
      last: 'Último'
    },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}
